import { BigNumber } from "@ethersproject/bignumber";
import { getAssetDecimals } from "../utils/asset";
import { getSubgraphqlURI, getV2SubgraphURI, isDevelopment, isProduction, } from "../utils/env";
import v1deployment from "./v1Deployments.json";
import v2deployment from "./v2Deployments.json";
import addresses from "./externalAddresses.json";
export var NETWORK_NAMES = {
    1: "mainnet",
    42: "kovan",
};
export var VaultVersionList = ["v1", "v2"];
export var VaultVersionListExludeV1 = VaultVersionList.filter(function (version) { return version !== "v1"; });
export var FullVaultList = [
    "ryvUSDC-ETH-P-THETA",
    "rETH-THETA",
    "rBTC-THETA",
    "rUSDC-ETH-P-THETA",
];
var ProdExcludeVault = [];
var PutThetaVault = [
    "rUSDC-ETH-P-THETA",
    "ryvUSDC-ETH-P-THETA",
];
// @ts-ignore
export var VaultList = !isProduction()
    ? FullVaultList
    : FullVaultList.filter(function (vault) { return !ProdExcludeVault.includes(vault); });
export var GAS_LIMITS = {
    "rETH-THETA": {
        v1: {
            deposit: 80000,
            withdraw: 100000,
        },
        v2: {
            deposit: 120000,
            withdrawInstantly: 120000,
        },
    },
    "rBTC-THETA": {
        v1: {
            deposit: 100000,
            withdraw: 140000,
        },
        v2: {
            deposit: 140000,
            withdrawInstantly: 120000,
        },
    },
    "rUSDC-ETH-P-THETA": {
        v1: {
            deposit: 120000,
            withdraw: 120000,
        },
        v2: {
            deposit: 140000,
            withdrawInstantly: 120000,
        },
    },
    "ryvUSDC-ETH-P-THETA": {
        v1: {
            deposit: 210000,
            withdraw: 210000,
        },
    },
};
export var VaultLiquidityMiningMap = isDevelopment()
    ? {
        "rUSDC-ETH-P-THETA": v1deployment.kovan.RibbonETHPutStakingReward,
        "rBTC-THETA": v1deployment.kovan.RibbonWBTCCoveredCallStakingReward,
        "rETH-THETA": v1deployment.kovan.RibbonETHCoveredCallStakingReward,
    }
    : {
        "rUSDC-ETH-P-THETA": v1deployment.mainnet.RibbonETHPutStakingReward,
        "rBTC-THETA": v1deployment.mainnet.RibbonWBTCCoveredCallStakingReward,
        "rETH-THETA": v1deployment.mainnet.RibbonETHCoveredCallStakingReward,
    };
export var isPutVault = function (vault) {
    return PutThetaVault.includes(vault);
};
export var VaultAddressMap = {
    "rUSDC-ETH-P-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonETHPut,
            v2: v1deployment.kovan.RibbonETHPut,
        }
        : {
            v1: v1deployment.mainnet.RibbonETHPut,
        },
    "rETH-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonETHCoveredCall,
            v2: v2deployment.kovan.RibbonThetaVaultETHCall,
        }
        : {
            v1: v1deployment.mainnet.RibbonETHCoveredCall,
            v2: v2deployment.mainnet.RibbonThetaVaultETHCall,
        },
    "rBTC-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonWBTCCoveredCall,
            v2: v2deployment.kovan.RibbonThetaVaultWBTCCall,
        }
        : {
            v1: v1deployment.mainnet.RibbonWBTCCoveredCall,
            v2: v2deployment.mainnet.RibbonThetaVaultWBTCCall,
        },
    "ryvUSDC-ETH-P-THETA": isDevelopment()
        ? {
            v1: v1deployment.kovan.RibbonYearnETHPut,
        }
        : {
            v1: v1deployment.mainnet.RibbonYearnETHPut,
        },
};
/**
 * Used to check if vault of given version exists. Only used for v2 and above
 * @param vaultOption
 * @returns boolean
 */
export var hasVaultVersion = function (vaultOption, version) {
    return !isProduction() && Boolean(VaultAddressMap[vaultOption][version]);
};
export var VaultNamesList = [
    "T-USDC-P-ETH",
    "T-ETH-C",
    "T-WBTC-C",
    "T-yvUSDC-P-ETH",
];
export var VaultNameOptionMap = {
    "T-USDC-P-ETH": "rUSDC-ETH-P-THETA",
    "T-ETH-C": "rETH-THETA",
    "T-WBTC-C": "rBTC-THETA",
    "T-yvUSDC-P-ETH": "ryvUSDC-ETH-P-THETA",
};
export var getEtherscanURI = function () {
    return isDevelopment() ? "https://kovan.etherscan.io" : "https://etherscan.io";
};
export var getSubgraphURIForVersion = function (vaultVersion) {
    switch (vaultVersion) {
        case "v1":
            return getSubgraphqlURI();
        case "v2":
            return getV2SubgraphURI();
    }
};
export var getAssets = function (vault) {
    switch (vault) {
        case "rUSDC-ETH-P-THETA":
        case "ryvUSDC-ETH-P-THETA":
            return "USDC";
        case "rETH-THETA":
            return "WETH";
        case "rBTC-THETA":
            return "WBTC";
    }
};
export var getOptionAssets = function (vault) {
    switch (vault) {
        case "rBTC-THETA":
            return "WBTC";
        case "rETH-THETA":
        case "rUSDC-ETH-P-THETA":
        case "ryvUSDC-ETH-P-THETA":
            return "WETH";
    }
};
export var getDisplayAssets = function (vault) {
    switch (vault) {
        case "rUSDC-ETH-P-THETA":
            return "USDC";
        case "rETH-THETA":
            return "WETH";
        case "rBTC-THETA":
            return "WBTC";
        case "ryvUSDC-ETH-P-THETA":
            return "yvUSDC";
    }
};
export var VaultMaxDeposit = {
    "rUSDC-ETH-P-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rUSDC-ETH-P-THETA")))),
    "rETH-THETA": BigNumber.from(50000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rETH-THETA")))),
    "rBTC-THETA": BigNumber.from(2000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("rBTC-THETA")))),
    "ryvUSDC-ETH-P-THETA": BigNumber.from(100000000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("ryvUSDC-ETH-P-THETA")))),
};
export var VaultWithdrawalFee = {
    "rUSDC-ETH-P-THETA": "1.0",
    "rETH-THETA": "0.5",
    "rBTC-THETA": "0.5",
    "ryvUSDC-ETH-P-THETA": "1.0",
};
export var getAirtableName = function (vault) {
    switch (vault) {
        case "rUSDC-ETH-P-THETA":
            return "T-USDC-P-ETH";
        case "rETH-THETA":
            return "T-ETH-C";
        case "rBTC-THETA":
            return "T-WBTC-C";
        case "ryvUSDC-ETH-P-THETA":
            return "T-YVUSDC-P-ETH";
    }
};
export var RibbonTokenAddress = isDevelopment()
    ? v1deployment.kovan.RibbonToken
    : v1deployment.mainnet.RibbonToken;
export var RibbonTokenBalancerPoolAddress = isDevelopment()
    ? v1deployment.kovan.RibbonTokenBalancerPool
    : // TODO: Update Mainnet Address
        "";
export var getERC20TokenAddress = function (token) {
    return isDevelopment()
        ? addresses.kovan.assets[token]
        : addresses.mainnet.assets[token];
};
//# sourceMappingURL=constants.js.map